import { render, staticRenderFns } from "./FormationReport.vue?vue&type=template&id=45d1f544&scoped=true&"
import script from "./FormationReport.vue?vue&type=script&lang=js&"
export * from "./FormationReport.vue?vue&type=script&lang=js&"
import style0 from "./FormationReport.vue?vue&type=style&index=0&id=45d1f544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d1f544",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
